import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { Firestore, doc, setDoc, getDoc } from '@angular/fire/firestore';
import { FormComponent } from '@tamilarasitech/shared-ui-components';

@Component({
  selector: 'app-emails',
  standalone: true,
  imports: [CommonModule, FormsModule, HttpClientModule, FormComponent],
  encapsulation: ViewEncapsulation.None,
  
  template: `
    <tt-form
      *ngIf="!showForm && dataLoaded && tableConfig"
      [config]="tableConfig"
      [existingData]="existingData"
      [showForm]="false"
      [fieldErrors]="fieldErrors"
      (openFormEvent)="openForm()">
    </tt-form>

    <div *ngIf="showForm">
      <ng-container *ngIf="tableConfig?.columns?.length > 0">
        <tt-form
          [config]="tableConfig"
          [addModalData]="addModalData"
          [fieldErrors]="fieldErrors"
          [uploadProgress]="uploadProgress"
          [showForm]="true"
          (submitForm)="onFormSubmit($event)"
          (cancel)="onFormCancel()"
          (fieldChange)="onFieldChange($event)">
        </tt-form>
      </ng-container>
    </div>
  `,
  styleUrls: [
]

})
export class EmailsComponent implements OnInit {
  tableConfig: any = null;
  addModalData: any = {};
  fieldErrors: any = {};
  uploadProgress: any = {};
  existingData: any = {};
  hasData = false;
  showForm = false;
  dataLoaded = false;

  constructor(private http: HttpClient, private firestore: Firestore) {}

  async ngOnInit() {
    // Load form config
    this.tableConfig = await this.http
      .get('/assets/json/app/form/emails.json')
      .toPromise();

    this.resetFormData();

    // Load existing Firestore data
    const docRef = doc(
      this.firestore,
      'data',
      'digitvcards',
      'config',
      'notifications'
    );
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const docData = docSnap.data() || {};
      const zeptoSettings = docData['email']?.['providers']?.['zeptomail']?.['settings'] || {};
      const logging = docData['security']?.['logging'] || {};

      this.tableConfig.columns.forEach((col: any) => {
        if (col.type === 'array-text') {
          this.addModalData[col.field] = zeptoSettings[col.field] || [''];
        } else if (['loggingEnabled','logLevel','sensitiveDataMasking'].includes(col.field)) {
          this.addModalData[col.field] =
            col.field === 'loggingEnabled'
              ? String(logging['enabled'] ?? 'true')
              : col.field === 'logLevel'
              ? logging['logLevel'] || 'info'
              : String(logging['sensitiveDataMasking'] ?? 'true');
        } else {
          this.addModalData[col.field] = zeptoSettings[col.field] || '';
        }
      });

      this.existingData = { ...this.addModalData };
      this.hasData = true;
    }

    this.dataLoaded = true;
  }

  openForm() {
    this.showForm = true;
  }

  resetFormData() {
    this.addModalData = {};
    this.fieldErrors = {};
    this.uploadProgress = {};

    if (!this.tableConfig?.columns) return;

    this.tableConfig.columns.forEach((col: any) => {
      this.addModalData[col.field] = col.type === 'array-text' ? [''] : '';
    });
  }

  private toBool(val: any): boolean {
    return String(val).toLowerCase() === 'true';
  }

  async onFormSubmit(form: any) {
    try {
      const payload = {
        email: {
          providers: {
            zeptomail: {
              enabled: this.toBool(form.enabled),
              token: form.token,
              settings: {
                fromEmail: form.fromEmail,
                fromName: form.fromName,
                replyTo: form.replyTo,
                verifiedSenders: form.verifiedSenders || [''],
              },
              templates: {
                adminOtp: {
                  subject: form.subject,
                  otpExpiryMinutes: Number(form.otpExpiryMinutes),
                  rateLimiting: {
                    maxAttemptsPerHour: Number(form.maxAttemptsPerHour),
                    maxAttemptsPerDay: Number(form.maxAttemptsPerDay),
                  },
                },
              },
            },
          },
        },
        security: {
          logging: {
            enabled: this.toBool(form.loggingEnabled),
            logLevel: form.logLevel,
            sensitiveDataMasking: this.toBool(form.sensitiveDataMasking),
          },
        },
      };

      const docRef = doc(
        this.firestore,
        'data',
        'digitvcards',
        'config',
        'notifications'
      );
      await setDoc(docRef, payload, { merge: true });

      console.log('Configuration saved:', payload);
      this.existingData = { ...this.addModalData };
      this.showForm = false;
    } catch (error) {
      console.error('Error saving configuration:', error);
    }
  }

  onFormCancel() {
    this.showForm = false;
  }

  onFieldChange(event: { field: string; value: any }) {
    this.addModalData[event.field] = event.value;
  }
}
